/**
 * 搜索状态提示（T12）。
 *
 * 空结果 / 检索失败时的**非阻断**提示：只提示，不改变对话流程。定位样式由父级传入。
 */

import type { CSSProperties, ReactElement } from 'react';

import { useComponentMeta } from '../../ui';
import { searchComponentMeta } from './componentMeta';
import styles from './search.module.css';

export interface SearchNoticeProps {
  message: string;
  style?: CSSProperties;
}

export function SearchNotice({ message, style }: SearchNoticeProps): ReactElement {
  const ref = useComponentMeta<HTMLParagraphElement>(searchComponentMeta('chat.search.notice'));
  return (
    <p
      ref={ref}
      className={styles.notice}
      style={style}
      data-ui-id="chat.search.notice"
      data-ui-role="text"
      role="status"
    >
      {message}
    </p>
  );
}
